export default {"src":"/_next/static/media/heart-filled.34a6d44b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};